module.exports = __webpack_public_path__ + "media/images/openweather/mapicons/en-a805ff16e5601b71a1c3478a760f60a5.png";